import { Link } from "@tanstack/react-router";

export function NotFoundPage() {
  return (
    <main className="content not-found-page">
      <div className="not-found-card">
        <div className="not-found-badge">404: Route not found</div>
        <h1 className="not-found-title">Lost in the Stack</h1>
        <p className="not-found-text">
          The router traced every packet, but the endpoint you requested does not
          exist in this universe. Double-check the URL or hop back to base.
        </p>
        <div className="not-found-terminal">
          <div>
            <span>peslar@core</span>:~$ curl /missing-page
          </div>
          <div>HTTP/1.1 404 Not Found</div>
          <div>Hint: try /tools for the good stuff.</div>
        </div>
        <div className="not-found-actions">
          <Link to="/" className="not-found-button">
            Return home
          </Link>
          <Link to="/tools" className="not-found-button ghost">
            Browse tools
          </Link>
        </div>
      </div>
    </main>
  );
}
